import { sumBy } from "lodash"
import { STADIUM_ORDER_STATES } from "./orderStates"
import { PAYMENT_TYPES } from "./paymentTypes"

// used in getTenderInfo to retrieve the matching display name 
// for specific payment types.
const paymentTypeKey = {
  [PAYMENT_TYPES.CASH]: "Cash",
  [PAYMENT_TYPES.QR_PAY]: 'QR Pay',
  [PAYMENT_TYPES.TICKET]: 'Ticket',
  [PAYMENT_TYPES.GIFT_CARD]: 'Gift Card'
}

const submittedOrFailedStates = [
  STADIUM_ORDER_STATES.SUBMITTED,
  STADIUM_ORDER_STATES.SUBMISSION_FAILED
]

// retrieves tender display information based on various flags
// or payment types set on the order
export const getTenderInfo = (order) => {
  const orderFirstPayment = order?.createOrderParams?.payments?.[0] ?? {}
  const paymentType = orderFirstPayment?.paymentType ?? ''
  const isRichCheckoutOrder = order?.isRichCheckout ?? false
  const isMultiPayment = order?.isMultiPayment ?? false
  const lastFour = order?.createOrderParams?.userAttributes?.last_4 ?? orderFirstPayment?.userAttributes?.last_4
  const issuer = order?.createOrderParams?.userAttributes?.freedompayIssuerName ?? orderFirstPayment?.userAttributes?.freedompayIssuerName
  const hasCreditCardInfo = issuer && lastFour
  const isSubmittedOrFailed = submittedOrFailedStates.includes(order?.createOrderParams?.state)

  let displayText
  let cardIssuer
  if(isMultiPayment) {
    displayText = "Split"
  } else if (hasCreditCardInfo) {
    displayText = `*${lastFour}`
    cardIssuer = issuer
  } else if (isRichCheckoutOrder) {
    displayText = "App"
  } else if (isSubmittedOrFailed) {
    displayText = "N/A"
  } else {
    displayText = paymentTypeKey[paymentType] ?? "Custom"
  }

  return { displayText, cardIssuer }  
}

// returns a formatted total of the order.
export const totalDisplay = (order) => {
  if (order.total) return `$${order.total}`
  if (order.amountInCents) return `$${(order.amountInCents / 100).toFixed(2)}`

  const totalInCents = sumBy(order.itemModels, 'priceInCents')
  return `$${(totalInCents / 100).toFixed(2)}`
}
